import { render, staticRenderFns } from "./MaintainerAttachmentTypes.vue?vue&type=template&id=650c427c&scoped=true&"
import script from "./MaintainerAttachmentTypes.vue?vue&type=script&lang=js&"
export * from "./MaintainerAttachmentTypes.vue?vue&type=script&lang=js&"
import style0 from "./MaintainerAttachmentTypes.vue?vue&type=style&index=0&id=650c427c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c427c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650c427c')) {
      api.createRecord('650c427c', component.options)
    } else {
      api.reload('650c427c', component.options)
    }
    module.hot.accept("./MaintainerAttachmentTypes.vue?vue&type=template&id=650c427c&scoped=true&", function () {
      api.rerender('650c427c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/vistas/MaintainerAttachmentTypes.vue"
export default component.exports